<template>
  <el-dialog :append-to-body="true" :visible.sync="dialog" :title="isAdd ? '新增产品' : '编辑产品信息'"
             :before-close="cancel" width="540px">
    <!--表单-->
    <el-form ref="form" :model="form" :rules="rules" size="small" label-width="110px" @submit.native.prevent>
      <!--产品名称-->
      <el-form-item label="产品名称" prop="product_name">
        <el-input v-model="form.product_name"/>
      </el-form-item>
      <!--审核状态-->
      <el-form-item label="审核状态" prop="state">
        <el-radio key="0" v-model="form.state" :label="0">未审核</el-radio>
        <el-radio key="1" v-model="form.state" :label="1">审核通过</el-radio>
      </el-form-item>
      <!--首页展示-->
      <el-form-item label="首页展示" prop="home_view">
        <el-radio key="0" v-model="form.home_view" :label="0">不展示</el-radio>
        <el-radio key="1" v-model="form.home_view" :label="1">展示</el-radio>
      </el-form-item>
      <!--产品描述-->
      <el-form-item label="产品描述" prop="md_product_desc">
        <el-button type="success" plain icon="el-icon-edit" @click="openEditor('md_product_desc')">打开编辑器</el-button>
      </el-form-item>
      <!--产品介绍-->
      <el-form-item label="产品介绍" prop="md_product_intro">
        <el-button type="warning" plain icon="el-icon-edit" @click="openEditor('md_product_intro')">打开编辑器</el-button>
      </el-form-item>
      <!--产品参数-->
      <el-form-item label="产品参数" prop="md_product_intro">
        <el-button type="danger" plain icon="el-icon-edit" @click="openEditor('md_product_params')">打开编辑器</el-button>
      </el-form-item>
      <!--上传-->
      <el-form-item label="上传文件">
        <el-upload multiple action="upload" :before-upload="beforeUpload"
                   :on-remove="removeFile" :file-list="fileList" accept="image/png,image/jpg,image/jpeg, image/bmp">
          <el-button size="small" type="primary">上传文件</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <!--对话框页脚-->
    <div slot="footer" class="dialog-footer">
      <el-button type="text" @click="cancel">取消</el-button>
      <el-button :loading="loading" type="primary" @click="doSubmit">确认</el-button>
    </div>
    <ProductMavonEditor ref="editor"/>
  </el-dialog>
</template>

<script>
import ProductMavonEditor from '@/views/AdminProduct/ProductMavonEditor'
import { addProduct, editProduct } from '@/api/product'
import { Message } from 'element-ui'
export default {
  name: 'productForm',
  components: { ProductMavonEditor },
  props: {
    isAdd: {
      type: Boolean,
      required: true
    },
    init: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      dialog: false,
      form: {
        product_name: '',             // 必传，产品名称
        category_id: '1',             // 必传，目前传‘1’
        state: 0,                     // 必传，0未审核，1审核通过
        home_view: 0,                 // 必传，首页展示，0不展示，1展示
        md_product_desc: '',          // 产品描述md
        html_product_desc: '',        // 产品描述html
        md_product_intro: '',         // 产品介绍md
        html_product_intro: '',       // 产品介绍html
        md_product_params: '',        // 产品参数md
        html_product_params: ''       // 产品参数html
      },
      fd: new FormData(),
      fileList: [],
      rules: {
        product_name: [
          { required: true, message: '请输入产品名称', trigger: 'blur' }
        ],
        state: [
          { required: true, message: '审核状态不得为空', trigger: 'blur' }
        ],
        home_view: [
          { required: true, message: '首页状态不得为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    /**
     * @description 上传文件之前的钩子函数
     * @param file
     * @returns {boolean}
     */
    beforeUpload (file) {
      this.fd.append('files', file)
      this.fileList.push(file)
      return false // 取消默认的action
    },
    /**
     * @description 移除文件时的钩子函数
     * @param file
     * @param fileList
     */
    removeFile (file, fileList) {
      if (file.status === 'ready') {
        return
      }
      this.fd.delete('files')
      fileList.forEach(item => {
        this.fd.append('files', item)
      })
    },
    /**
     * @description 打开编辑器
    */
    // eslint-disable-next-line camelcase
    openEditor (type) {
      this.$refs['editor'].dialog = true
      this.$refs['editor'].info_type = type
      switch (type) {
        case 'md_product_desc':
          this.$refs['editor'].mdValue = this.$store.getters.md_product_desc
          break
        case 'md_product_intro':
          this.$refs['editor'].mdValue = this.$store.getters.md_product_intro
          break
        case 'md_product_params':
          this.$refs['editor'].mdValue = this.$store.getters.md_product_params
          break
      }
    },
    /**
     * @description 提交表单
    */
    doSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.form.md_product_desc = this.$store.getters.md_product_desc
          this.form.html_product_desc = this.$store.getters.html_product_desc
          this.form.md_product_intro = this.$store.getters.md_product_intro
          this.form.html_product_intro = this.$store.getters.html_product_intro
          this.form.md_product_params = this.$store.getters.md_product_params
          this.form.html_product_params = this.$store.getters.html_product_params
          if (this.isAdd) {
            this.doAdd()
          } else {
            this.doEdit()
          }
        } else {
          Message({
            message: '您有未完成的必填项。',
            type: 'error',
            duration: 3000
          })
        }
      })
    },
    doAdd () {
      let _form = this.form
      if (this.fd.getAll('files').length === 0) {
        Message({
          message: '还未选择文件。',
          type: 'error',
          duration: 3000
        })
        this.loading = false
        return
      }
      for (let key in _form) {
        if (_form.hasOwnProperty(key)) {
          this.fd.append(key, _form[key])
        }
      }
      addProduct(this.fd).then(res => {
        if (res.status === 200) {
          this.$notify({
            title: '成功',
            message: '产品添加成功。',
            type: 'success',
            duration: 3000
          })
          this.resetForm()
          this.init()
        } else {
          this.$notify({
            title: '失败',
            message: res.msg,
            type: 'error',
            duration: 3000
          })
        }
        this.loading = false
      })
    },
    doEdit () {
      let _form = this.form
      for (let key in _form) {
        if (_form.hasOwnProperty(key)) {
          this.fd.append(key, _form[key])
        }
      }
      editProduct(this.fd).then(res => {
        if (res.status === 200) {
          this.$notify({
            title: '成功',
            message: '产品信息修改成功。',
            type: 'success',
            duration: 3000
          })
          this.resetForm()
          this.init()
        } else {
          this.$notify({
            title: '失败',
            message: res.msg,
            type: 'error',
            duration: 3000
          })
        }
        this.loading = false
      })
    },
    cancel () {
      this.$confirm(`确定关闭对话框而不添加新产品？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.resetForm()
      }).catch(() => {
      })
    },
    /**
     * @description 恢复表单
     */
    resetForm () {
      this.dialog = false
      this.$refs['form'].resetFields()
      this.form = {
        product_name: '',             // 必传，产品名称
        category_id: '1',             // 必传，目前传‘1’
        state: 0,                     // 必传，0未审核，1审核通过
        home_view: 0,                 // 必传，首页展示，0不展示，1展示
        md_product_desc: '',          // 产品描述md
        html_product_desc: '',        // 产品描述html
        md_product_intro: '',         // 产品介绍md
        html_product_intro: '',       // 产品介绍html
        md_product_params: '',        // 产品参数md
        html_product_params: ''       // 产品参数html
      }
      this.fileList = []
      this.fd = new FormData()
      this.$store.commit('set_md_product_desc', '')
      this.$store.commit('set_html_product_desc', '')
      this.$store.commit('set_md_product_intro', '')
      this.$store.commit('set_html_product_intro', '')
      this.$store.commit('set_md_product_params', '')
      this.$store.commit('set_html_product_params', '')
    }
  }
}
</script>

<style scoped>

</style>
